import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface PartnerCardProps {
  partner: {
    id: number;
    name: string;
    type: string;
    logo: string;
    logoAlt: string;
    description: string;
    country: string;
    established: string;
    website: string;
    impact: string;
  };
  onViewDetails: (id: number) => void;
}

const PartnerCard: React.FC<PartnerCardProps> = ({ partner, onViewDetails }) => {
  return (
    <div className="bg-card rounded-lg shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-border">
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="w-20 h-20 bg-background rounded-lg overflow-hidden flex items-center justify-center">
            <AppImage
              src={partner.logo}
              alt={partner.logoAlt}
              className="w-full h-full object-contain"
            />
          </div>
          <span className="px-3 py-1 bg-secondary/10 text-secondary text-xs font-semibold rounded-full">
            {partner.type}
          </span>
        </div>

        <h3 className="text-xl font-headline font-bold text-foreground mb-2">
          {partner.name}
        </h3>

        <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
          {partner.description}
        </p>

        <div className="space-y-2 mb-4">
          <div className="flex items-center text-sm text-foreground">
            <Icon name="MapPinIcon" size={16} className="mr-2 text-primary" />
            <span>{partner.country}</span>
          </div>
          <div className="flex items-center text-sm text-foreground">
            <Icon name="CalendarIcon" size={16} className="mr-2 text-primary" />
            <span>Since {partner.established}</span>
          </div>
          <div className="flex items-center text-sm text-foreground">
            <Icon name="ChartBarIcon" size={16} className="mr-2 text-primary" />
            <span>{partner.impact}</span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <a
            href={partner.website}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary hover:text-secondary transition-colors duration-200 flex items-center"
          >
            <Icon name="GlobeAltIcon" size={16} className="mr-1" />
            Visit Website
          </a>
          <button
            onClick={() => onViewDetails(partner.id)}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-semibold hover:bg-secondary transition-colors duration-200"
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default PartnerCard;